// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const magearna_original: PokeData = {
  "id": 10147,
  "name": "magearna-original",
  "height": 10,
  "weight": 805,
  "base_experience": 300,
  "types": [
    PokeType.STEEL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "sonic-boom",
    "psybeam",
    "aurora-beam",
    "defense-curl",
    "mind-reader",
    "zap-cannon",
    "lock-on",
    "rollout",
    "pain-split",
    "helping-hand",
    "trick",
    "iron-defense",
    "gyro-ball",
    "trump-card",
    "lucky-chant",
    "heart-swap",
    "aura-sphere",
    "mirror-shot",
    "flash-cannon",
    "iron-head",
    "synchronoise",
    "shift-gear",
    "crafty-shield",
    "magnetic-flux",
    "gear-up",
    "fleur-cannon"
  ],
  "moves": [
    "zap-cannon",
    "gear-up",
    "moonblast",
    "iron-defense",
    "spirit-break",
    "magnet-bomb",
    "metal-claw",
    "metal-burst",
    "magnet-pull",
    "play-rough",
    "scrap-throw",
    "smart-strike",
    "dazzling-gleam"
  ],
  "evolution_chain": {
    "id": 422,
    "item": null,
    "species": [
      {
        "name": "magearna",
        "order": 801,
        "types": [
          PokeType.STEEL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 89,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
